import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import changeImage from '../../assets/changeImage.png';
import editProf from '../../assets/editProf.png';
import profile from '../../assets/profile.png';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import ImageUploader from 'react-images-upload';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ErrorRequest from '../ErrorRequest';
import CustomTextField from '../components/customTextField';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const filter = createFilterOptions();

export default function EditInsurance(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dataKategori, setDataKategori] = useState([])
    const [kategori, setKategori] = React.useState(null);
    const [code, setCode] = React.useState("")
    const [provider, setProvider] = React.useState("")
    const [id, setId] = useState(null)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleError, setVisibleError] = React.useState(false);
    const [errorCode, setErrorCode] = React.useState(false)
    const [errorProvider, setErrorProvider] = React.useState(false)
    const [errorKategori, setErrorKategori] = React.useState(false)
    const [texterrorcode, setTextErrorCode] = React.useState(null)
    const [texterrorProvider, setTextErrorProvider] = React.useState(null)
    const [texterrorKategori, setTextErrorKategori] = React.useState(null)

    React.useEffect(() => {
        getDetailInsurance()
        getDataProviderCategory()
    }, [])

    // const handleOnChange = (e) => {
    //     setName(e.target.value)
    //     setErrorName(false)
    //     setTextErrorName(null)
    //     forceUpdate()
    // }

    const forceUpdate = React.useReducer(bool => !bool)[1];
                
    const getDetailInsurance = () => {
        api.create().getDetailInsurance(props.id).then(response => {
            console.log(response);
            if (response.data) {
                setId(response.data.data.id)
                setCode(response.data.data.code)
                setProvider(response.data.data.name)
                setKategori(response.data.data.type)
                // let idx = dataKategori.findIndex((val) => val.value === response.data.data.type)
                // console.log(dataKategori);
                //     if (idx > -1) {
                //         setKategori(dataKategori[idx])
                //     }
                    
                forceUpdate()
            }
        })
    }

    const getDataProviderCategory = () => {
        api.create().getListKategoriProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataKategori = []
                    response.data.data.map(item => {
                        dataKategori.push({
                            value: item.type
                        })
                    })
                    setDataKategori(dataKategori)
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const doSubmit = (e) => {
        console.log(kategori);
        if (code === "") {
            setErrorCode(true)
            setTextErrorCode("Kode Provider wajib diisi")
        } else if (provider === "") {
            setErrorProvider(true)
            setTextErrorProvider("Provider wajib diisi")
        } else if (!kategori) {
            setErrorKategori(true)
            setTextErrorKategori("Kategori Provider wajib diisi")
        }
        else {
            let formData = new FormData()
            formData.append('id', id)
            formData.append('code', code)
            formData.append('name', provider)
            formData.append('type', kategori.value)
            console.log(...formData);
            api.create().updateInsurance(formData).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Succes")
                        props.onClose()
                        props.getData()
                    } else {
                        setMessageAlert(response.data.data)
                        setVisibleError(true)
                    }
                }
            })
        }
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Provider Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <CustomTextField
                            required={true}
                            label={"Kode Provider"}
                            error={errorCode}
                            helperText={texterrorcode}
                            onChange={(val) => {
                                setCode(val)
                                setErrorCode(false)
                                setTextErrorCode(null)
                            }}
                            value={code}
                        />
                    </div>
                    <div className="column-2">
                        <CustomTextField
                            required={true}
                            style={{ width: '100%' }}
                            label={"Provider"}
                            error={errorProvider}
                            helperText={texterrorProvider}
                            onChange={(val) => {
                                setProvider(val)
                                setErrorProvider(false)
                                setTextErrorProvider(null)
                            }}
                            value={provider}
                        />
                    </div>
                    <div className="column-1">
                        <div style={{}}>
                            <Autocomplete
                                value={kategori}
                                onChange={(event, newValue) => {
                                    if (typeof newValue === 'string') {
                                        setKategori({
                                            value: newValue,
                                        });
                                    } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                        setKategori({
                                            value: newValue.inputValue,
                                        });
                                    } else {
                                        setKategori(newValue);
                                    }
                                    setErrorKategori(false)
                                    setTextErrorKategori(null)
                                }}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);

                                    // Suggest the creation of a new value
                                    if (params.inputValue !== '') {
                                        filtered.push({
                                            inputValue: params.inputValue,
                                            value: `Add "${params.inputValue}"`,
                                        });
                                    }
                                    // console.log(params.inputValue);

                                    return filtered;
                                }}
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                                id="kategori"
                                options={dataKategori}
                                getOptionLabel={(option) => {
                                    // Value selected with enter, right from the input
                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    // Add "xxx" option created dynamically
                                    if (option.inputValue) {
                                        return option.inputValue;
                                    }
                                    // Regular option
                                    return option.value;
                                }}
                                renderOption={(option) => option.value}
                                style={{ marginTop: 15 }}
                                freeSolo
                                // disableClearable
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required={true}
                                        error={errorKategori}
                                        helperText={texterrorKategori}
                                        InputLabelProps={{
                                            style: {
                                                color: '#7e8085',
                                                fontSize: 14
                                            }
                                        }}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        label="Kategori Provider"
                                    />
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
            {
                visibleError ?
                    <ErrorRequest
                        message={messageAlert}
                        close={() => setVisibleError(false)}
                    />
                    : null
            }
        </div>
    )
}